import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20.229}
    height={20.52}
    {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={7.213}
        y1={-5.359}
        x2={7.508}
        y2={-6.661}
        gradientUnits="objectBoundingBox">
        <stop offset={0.04} stopColor="#fcfffe" />
        <stop offset={0.42} stopColor="#a3a3a3" />
        <stop offset={1} stopColor="#feffff" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={7.188}
        y1={-6.17}
        x2={7.226}
        y2={-6.17}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#999" />
        <stop offset={0.65} stopColor="#ababab" />
      </linearGradient>
      <linearGradient id="c" x1={7.271} y1={-0.451} x2={7.556} y2={-1.792} xlinkHref="#a" />
      <linearGradient id="d" x1={7.62} y1={-1.097} x2={7.659} y2={-1.097} xlinkHref="#b" />
    </defs>
    <g data-name={20}>
      <path
        data-name="Path 10268"
        d="M6.819 15.12a.46.46 0 0 1-.638.662l-1.622-1.56a.46.46 0 0 1 .638-.663Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10269"
        d="M5.464 14.736a1.806 1.806 0 0 0 1.019.676.958.958 0 0 0 .468-.043.459.459 0 0 1-.77.414l-1.622-1.56a.459.459 0 0 1 .533-.736 1.454 1.454 0 0 0 .372 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10270"
        d="M5.317 14.765a3.056 3.056 0 0 0 1.306.94.849.849 0 0 0 .233.035c-.008.01-.015.022-.025.032a.46.46 0 0 1-.65.012l-1.622-1.56a.458.458 0 0 1 .24-.783 1.606 1.606 0 0 0 .518 1.325Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10271"
        d="M6.18 15.783a.46.46 0 1 1-.637.663l-1.622-1.561a.46.46 0 0 1 .638-.662l1.622 1.56Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10272"
        d="M4.826 15.394a1.8 1.8 0 0 0 1.02.676.955.955 0 0 0 .467-.043.459.459 0 0 1-.77.413l-1.622-1.561a.458.458 0 0 1 .533-.735 1.454 1.454 0 0 0 .372 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10273"
        d="M4.68 15.427a3.051 3.051 0 0 0 1.306.94.849.849 0 0 0 .233.035.33.33 0 0 1-.025.032.46.46 0 0 1-.65.012l-1.622-1.561a.458.458 0 0 1 .24-.782 1.612 1.612 0 0 0 .518 1.324Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10274"
        d="M6.818 15.12a.46.46 0 0 1 .012.65.489.489 0 0 1-.038.032A4.449 4.449 0 0 0 4.5 13.631a.486.486 0 0 1 .047-.059.46.46 0 0 1 .65-.013Z"
        fill="#7f3004"
      />
      <path
        data-name="Path 10275"
        d="M2.484 19.641a1.089 1.089 0 0 1-.795.867 1.439 1.439 0 0 1-1.173-.423l-.021-.02-.021-.02a1.434 1.434 0 0 1-.467-1.156 1.09 1.09 0 0 1 .836-.827 4.836 4.836 0 0 0 1.641 1.58Z"
        fill="#b7bdb5"
      />
      <path
        data-name="Path 10276"
        d="M2.171 19.712a.722.722 0 0 1-1.1-.224.864.864 0 0 1-.027-.866 2.564 2.564 0 0 0 1.131 1.089Z"
        fill="#e1e5df"
      />
      <path
        data-name="Path 10277"
        d="M.911 18.303a.926.926 0 0 0-.07 1.281 1.1 1.1 0 0 0 1.507.422 1.029 1.029 0 0 1-.658.5 1.439 1.439 0 0 1-1.173-.423l-.021-.02-.021-.02a1.434 1.434 0 0 1-.467-1.156 1.09 1.09 0 0 1 .836-.827.452.452 0 0 0 .067.242Z"
        fill="#5c605a"
      />
      <path data-name="Path 10278" d="m7.228 14.602-.764-.735L19.812 0l-.3 6.63Z" fill="#eee" />
      <path
        data-name="Path 10279"
        d="m19.811 0-.3 6.63-12.282 7.972-.261-.252 11.429-8.148.776-5.538Z"
        fill="#eee"
      />
      <path
        data-name="Path 10280"
        d="M18.58 6.38 6.966 14.35l11.429-8.146.776-5.538Z"
        fill="#fff"
      />
      <path
        data-name="Path 10281"
        d="m135.028 59.057-.3-.288L145.384 47.7l-1.472 1.878Z"
        transform="translate(-128.266 -44.902)"
        fill="url(#a)"
      />
      <path data-name="Path 10282" d="m6.464 13.867-.764-.736L13.2.554 19.813 0Z" fill="#c8c8c8" />
      <path
        data-name="Path 10283"
        d="M8.815 11.426s.478-2.9.516-4.383l2.453-4.117c.345 1.466.676 2.935.96 4.416l-3.93 4.084Z"
        fill="#b1b5b5"
      />
      <path
        data-name="Path 10284"
        d="m131.069 58.769-.3-.288 9.133-9.238 1.82-1.543Z"
        transform="translate(-124.606 -44.902)"
        fill="url(#b)"
      />
      <path
        data-name="Path 10285"
        d="M5.7 13.13 13.2.553l6.613-.554-.64.664-5.5.987-7.708 11.731Z"
        fill="#c8c8c8"
      />
      <path
        data-name="Path 10286"
        d="m13.511 1.504 5.66-.836-5.5.987L5.96 13.382Z"
        fill="#ababab"
      />
      <path
        data-name="Path 10287"
        d="M5.503 12.237a5.779 5.779 0 0 0 2.626 2.527c.533.127.833.356.478.99-.336.6-.914.919-1.175.742s-.164-.3-.529-.859a8.693 8.693 0 0 0-2.224-2.141c-.571-.343-.685-.23-.88-.5s.11-.843.7-1.2c.62-.379.86-.088 1.007.44Z"
        fill="#d36200"
      />
      <path
        data-name="Path 10288"
        d="M4.904 12.763a4.567 4.567 0 0 0 1.164 1.052c.623.525.988 1.235 1.581 1.767a.915.915 0 0 0 .925.227c-.34.564-.889.856-1.141.686-.274-.184-.164-.3-.529-.859a8.693 8.693 0 0 0-2.224-2.141c-.571-.343-.685-.23-.88-.5s.11-.843.7-1.2c.306-.187.518-.211.674-.124a.725.725 0 0 0-.267 1.09Z"
        fill="#bc5304"
      />
      <path
        data-name="Path 10289"
        d="M4.659 13.107c.164.193 1 .734 1.136.861a15.1 15.1 0 0 1 1.26 1.464c.312.386.748.805 1.2.775-.3.289-.641.41-.824.286-.274-.184-.164-.3-.529-.859a8.692 8.692 0 0 0-2.224-2.141c-.571-.343-.685-.23-.88-.5s.11-.843.7-1.2a.759.759 0 0 1 .6-.153.99.99 0 0 0-.587.52.819.819 0 0 0 .147.945Z"
        fill="#9b4104"
      />
      <path
        data-name="Path 10290"
        d="M6.077 15.943c-.274.136-.623-.407-.788-.6-.122-.143-.722-.754-.648-.907.23.241.49.467.737.7.204.197.834.739.699.807Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10291"
        d="M5.543 16.445a.46.46 0 1 1-.638.662l-1.621-1.561a.46.46 0 0 1 .638-.663l1.622 1.561Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10292"
        d="M4.188 16.06a1.8 1.8 0 0 0 1.02.676.955.955 0 0 0 .467-.043.459.459 0 0 1-.771.414l-1.621-1.561a.459.459 0 0 1 .533-.736 1.456 1.456 0 0 0 .372 1.25Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10293"
        d="M4.041 16.089a3.06 3.06 0 0 0 1.306.94.848.848 0 0 0 .233.035l-.025.031a.46.46 0 0 1-.651.012l-1.621-1.561a.459.459 0 0 1 .24-.783 1.609 1.609 0 0 0 .518 1.325Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10294"
        d="M5.44 16.605c-.274.136-.623-.407-.789-.6-.122-.143-.722-.754-.647-.908.23.241.49.467.737.7.2.195.833.737.7.8Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10295"
        d="M4.906 17.108a.46.46 0 0 1-.638.663l-1.622-1.56a.46.46 0 1 1 .638-.663l1.621 1.561Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10296"
        d="M3.551 16.722a1.806 1.806 0 0 0 1.019.676.956.956 0 0 0 .468-.043.459.459 0 0 1-.77.415l-1.622-1.56a.458.458 0 0 1 .533-.736 1.453 1.453 0 0 0 .371 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10297"
        d="M3.404 16.751a3.054 3.054 0 0 0 1.306.94.821.821 0 0 0 .233.035.392.392 0 0 1-.025.032.46.46 0 0 1-.65.013l-1.622-1.56a.458.458 0 0 1 .24-.784 1.609 1.609 0 0 0 .518 1.324Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10298"
        d="M4.804 17.267c-.274.136-.623-.407-.789-.6-.122-.143-.722-.754-.648-.908.23.241.49.467.737.7.2.2.833.737.7.8Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10299"
        d="M4.268 17.77a.46.46 0 0 1-.638.663l-1.621-1.561a.46.46 0 1 1 .638-.662l1.622 1.56Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10300"
        d="M2.913 17.385a1.8 1.8 0 0 0 1.02.676.958.958 0 0 0 .468-.043.459.459 0 0 1-.77.414L2.01 16.871a.458.458 0 0 1 .533-.735 1.454 1.454 0 0 0 .371 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10301"
        d="M2.766 17.413a3.054 3.054 0 0 0 1.306.94.815.815 0 0 0 .233.034.325.325 0 0 1-.025.032.46.46 0 0 1-.65.013l-1.621-1.561a.458.458 0 0 1 .24-.783 1.609 1.609 0 0 0 .518 1.325Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10302"
        d="M4.165 17.93c-.274.135-.623-.407-.789-.6-.122-.143-.722-.754-.648-.908.23.241.49.467.737.706.204.193.834.735.7.802Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10303"
        d="M3.63 18.432a.46.46 0 1 1-.638.662l-1.621-1.561a.46.46 0 1 1 .638-.662Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10304"
        d="M2.276 18.048a1.808 1.808 0 0 0 1.02.676.955.955 0 0 0 .467-.043.458.458 0 0 1-.77.413l-1.621-1.561a.458.458 0 0 1 .533-.735 1.453 1.453 0 0 0 .372 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10305"
        d="M2.129 18.076a3.066 3.066 0 0 0 1.306.94.82.82 0 0 0 .233.035.392.392 0 0 1-.025.032.46.46 0 0 1-.651.012l-1.621-1.561a.46.46 0 0 1-.013-.65.452.452 0 0 1 .252-.132 1.609 1.609 0 0 0 .519 1.324Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10306"
        d="M3.527 18.592c-.274.136-.623-.406-.789-.6-.122-.143-.722-.754-.648-.908.23.242.49.467.737.706.2.195.833.737.7.8Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10307"
        d="M2.993 19.094a.46.46 0 1 1-.637.662l-1.621-1.56a.46.46 0 1 1 .638-.663l1.621 1.561Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10308"
        d="M1.638 18.709a1.8 1.8 0 0 0 1.02.676.954.954 0 0 0 .467-.043.459.459 0 0 1-.77.414l-1.621-1.56a.459.459 0 0 1 .533-.736 1.451 1.451 0 0 0 .372 1.249Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10309"
        d="M1.492 18.738a3.039 3.039 0 0 0 1.306.94.849.849 0 0 0 .233.035.329.329 0 0 1-.025.032.46.46 0 0 1-.65.012l-1.621-1.56a.458.458 0 0 1 .239-.783 1.608 1.608 0 0 0 .518 1.325Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10310"
        d="M2.889 19.254c-.274.136-.623-.407-.789-.6-.121-.143-.722-.753-.648-.908.23.241.49.467.737.7.2.2.833.737.7.8Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10311"
        d="M6.345 15.228c-.076 0-.2-.1-.281-.172a2.458 2.458 0 0 1-.223-.288c-.257-.337-.505-.429-.587-.623a3.117 3.117 0 0 1 .68.554c.083.08.522.5.412.528Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10312"
        d="M5.422 12.454a2.209 2.209 0 0 0 .321.466 10.075 10.075 0 0 0 1.684 1.657 3.168 3.168 0 0 0 .621.37c.153.066.488.066.533.238-.008.495-.421.528-.713.218-.267-.285-.5-.591-.766-.873a23.68 23.68 0 0 1-1.736-1.671c-.062-.08-.558-.985-.152-.851.094.031.163.357.208.444Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10313"
        d="M15.01 13.574a.46.46 0 0 1 .64.66l-1.614 1.568a.46.46 0 0 1-.641-.66Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10314"
        d="M14.586 14.914a1.8 1.8 0 0 0 .71-1 .952.952 0 0 0-.027-.468.459.459 0 0 1 .388.784l-1.614 1.568a.458.458 0 0 1-.717-.558 1.455 1.455 0 0 0 1.261-.329Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10315"
        d="M14.605 15.067a3.06 3.06 0 0 0 .983-1.274.86.86 0 0 0 .043-.231c.01.009.021.016.031.026a.46.46 0 0 1-.01.65l-1.614 1.568a.459.459 0 0 1-.65-.01.45.45 0 0 1-.124-.256 1.607 1.607 0 0 0 1.341-.473Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10316"
        d="M15.652 14.233a.46.46 0 1 1 .641.659l-1.615 1.568a.46.46 0 0 1-.641-.659l1.614-1.568Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10317"
        d="M15.222 15.578a1.8 1.8 0 0 0 .71-1 .952.952 0 0 0-.027-.468.458.458 0 0 1 .388.783l-1.615 1.568a.459.459 0 0 1-.718-.557 1.453 1.453 0 0 0 1.26-.329Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10318"
        d="M15.246 15.722a3.054 3.054 0 0 0 .983-1.274.829.829 0 0 0 .042-.231c.011.009.021.016.031.026a.46.46 0 0 1-.01.65l-1.615 1.568a.458.458 0 0 1-.774-.265 1.61 1.61 0 0 0 1.341-.473Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10319"
        d="M15.01 13.574a.46.46 0 0 1 .65.01.356.356 0 0 1 .03.039 4.452 4.452 0 0 0-2.246 2.218.5.5 0 0 1-.057-.049.46.46 0 0 1 .009-.65Z"
        fill="#7f3004"
      />
      <path
        data-name="Path 10320"
        d="M19.383 18.058a1.089 1.089 0 0 1 .839.824 1.438 1.438 0 0 1-.462 1.158l-.021.02-.021.02a1.437 1.437 0 0 1-1.171.428 1.09 1.09 0 0 1-.8-.864 4.836 4.836 0 0 0 1.634-1.587Z"
        fill="#b7bdb5"
      />
      <path
        data-name="Path 10321"
        d="M19.444 18.375a.722.722 0 0 1-.26 1.1.864.864 0 0 1-.866 0 2.569 2.569 0 0 0 1.127-1.094Z"
        fill="#e1e5df"
      />
      <path
        data-name="Path 10322"
        d="M17.994 19.586a.926.926 0 0 0 1.278.113 1.1 1.1 0 0 0 .472-1.492 1.03 1.03 0 0 1 .478.674 1.438 1.438 0 0 1-.462 1.158l-.021.02-.021.02a1.437 1.437 0 0 1-1.171.428 1.09 1.09 0 0 1-.8-.864.45.45 0 0 0 .244-.06Z"
        fill="#5c605a"
      />
      <path data-name="Path 10323" d="m14.506 13.147-.76.739L.336.079l6.616.524Z" fill="#eee" />
      <path
        data-name="Path 10324"
        d="m.336.079 6.616.524 7.554 12.544-.259.252-7.76-11.7L.979.737Z"
        fill="#eee"
      />
      <path data-name="Path 10325" d="M6.672 1.524 14.248 13.4 6.488 1.7.979.741Z" fill="#fff" />
      <path
        data-name="Path 10326"
        d="m100.462 59.331-.3.289L89.46 48.6l1.828 1.535Z"
        transform="translate(-86.417 -45.734)"
        fill="url(#c)"
      />
      <path data-name="Path 10327" d="m13.746 13.886-.761.739L.667 6.707.336.079Z" fill="#c8c8c8" />
      <path
        data-name="Path 10328"
        d="M11.384 11.454s-2.881-.575-4.364-.663L2.99 8.2c1.477-.3 2.957-.577 4.445-.811l3.948 4.064Z"
        fill="#b1b5b5"
      />
      <path
        data-name="Path 10329"
        d="m100.164 59.62-.3.289-8.925-9.437L89.46 48.6Z"
        transform="translate(-86.417 -45.734)"
        fill="url(#d)"
      />
      <path
        data-name="Path 10330"
        d="M12.985 14.625.667 6.707.336.079l.643.662.8 5.534 11.465 8.1Z"
        fill="#c8c8c8"
      />
      <path data-name="Path 10331" d="M1.624 6.427.979.741l.8 5.534 11.465 8.1Z" fill="#c8c8c8" />
      <path
        data-name="Path 10332"
        d="M12.085 14.79a5.779 5.779 0 0 0 2.614-2.539c.144-.529.384-.821 1-.444.589.357.887.944.7 1.2s-.308.154-.876.5a8.712 8.712 0 0 0-2.215 2.151c-.362.559-.252.676-.525.862s-.839-.138-1.179-.737c-.351-.632-.053-.863.481-.993Z"
        fill="#d36200"
      />
      <path
        data-name="Path 10333"
        d="M12.591 15.407a4.577 4.577 0 0 0 1.09-1.127c.546-.605 1.268-.947 1.819-1.52a.915.915 0 0 0 .258-.917c.552.359.826.917.648 1.164-.193.267-.308.154-.876.5a8.713 8.713 0 0 0-2.215 2.151c-.362.559-.252.676-.525.862s-.839-.138-1.179-.737c-.177-.312-.193-.525-.1-.678a.726.726 0 0 0 1.081.3Z"
        fill="#bc5304"
      />
      <path
        data-name="Path 10334"
        d="M12.927 15.664c.2-.157.768-.979.9-1.107a15.155 15.155 0 0 1 1.506-1.21c.4-.3.83-.721.815-1.174.28.312.388.654.259.833-.193.267-.308.154-.876.5a8.713 8.713 0 0 0-2.215 2.151c-.362.559-.252.676-.525.862s-.839-.138-1.179-.737a.758.758 0 0 1-.133-.608.991.991 0 0 0 .5.6.82.82 0 0 0 .949-.115Z"
        fill="#9b4104"
      />
      <path
        data-name="Path 10335"
        d="M15.809 14.342c.127.278-.427.609-.627.768-.147.117-.777.7-.929.617.249-.222.483-.474.729-.713.202-.197.765-.81.827-.672Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10336"
        d="M16.293 14.892a.46.46 0 0 1 .64.66l-1.615 1.568a.46.46 0 0 1-.641-.66l1.615-1.568Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10337"
        d="M15.862 16.234a1.8 1.8 0 0 0 .71-1 .96.96 0 0 0-.028-.468.459.459 0 0 1 .388.784l-1.615 1.568a.459.459 0 0 1-.718-.558 1.457 1.457 0 0 0 1.262-.329Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10338"
        d="M15.887 16.381a3.054 3.054 0 0 0 .983-1.274.852.852 0 0 0 .042-.231c.01.009.021.016.03.026a.46.46 0 0 1-.01.651l-1.615 1.568a.458.458 0 0 1-.774-.266 1.611 1.611 0 0 0 1.342-.472Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10339"
        d="M16.449 15.001c.126.278-.427.61-.627.768-.147.116-.778.7-.929.616.249-.221.483-.474.729-.713.201-.196.765-.807.827-.671Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10340"
        d="M16.933 15.552a.46.46 0 0 1 .641.66L15.96 17.78a.46.46 0 1 1-.641-.66l1.615-1.568Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10341"
        d="M16.503 16.893a1.8 1.8 0 0 0 .71-1 .96.96 0 0 0-.027-.468.459.459 0 0 1 .388.784l-1.614 1.568a.458.458 0 0 1-.718-.557 1.454 1.454 0 0 0 1.261-.329Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10342"
        d="M16.525 17.041a3.048 3.048 0 0 0 .983-1.274.832.832 0 0 0 .043-.231l.03.026a.459.459 0 0 1-.009.65l-1.614 1.568a.458.458 0 0 1-.774-.265 1.61 1.61 0 0 0 1.341-.473Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10343"
        d="M17.09 15.66c.126.279-.428.609-.627.768-.147.116-.778.7-.929.617.249-.222.484-.474.73-.713.2-.2.765-.808.827-.672Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10344"
        d="M17.574 16.211a.46.46 0 0 1 .641.66L16.6 18.439a.46.46 0 1 1-.64-.66Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10345"
        d="M17.143 17.553a1.8 1.8 0 0 0 .71-1 .96.96 0 0 0-.027-.468.459.459 0 0 1 .388.784l-1.615 1.568a.458.458 0 0 1-.717-.557 1.453 1.453 0 0 0 1.261-.327Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10346"
        d="M17.167 17.701a3.054 3.054 0 0 0 .984-1.275.826.826 0 0 0 .042-.231.35.35 0 0 1 .031.026.46.46 0 0 1-.009.65L16.6 18.439a.457.457 0 0 1-.774-.265 1.608 1.608 0 0 0 1.341-.473Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10347"
        d="M17.734 16.32c.126.278-.428.609-.627.768-.147.116-.778.7-.929.617.249-.222.484-.474.73-.713.2-.2.765-.807.827-.671Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10348"
        d="M18.214 16.871a.46.46 0 1 1 .64.66l-1.615 1.568a.46.46 0 1 1-.64-.66Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10349"
        d="M17.784 18.212a1.8 1.8 0 0 0 .71-1 .961.961 0 0 0-.027-.468.459.459 0 0 1 .388.784l-1.615 1.568a.458.458 0 0 1-.717-.557 1.455 1.455 0 0 0 1.261-.327Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10350"
        d="M17.808 18.36a3.054 3.054 0 0 0 .983-1.274.8.8 0 0 0 .042-.231c.011.009.021.016.031.026a.46.46 0 0 1-.01.651L17.239 19.1a.46.46 0 0 1-.65-.009.452.452 0 0 1-.124-.256 1.608 1.608 0 0 0 1.341-.473Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10351"
        d="M18.37 16.98c.126.278-.428.609-.627.768-.147.116-.778.7-.93.617.249-.222.484-.474.73-.713.2-.2.765-.807.827-.671Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10352"
        d="M18.856 17.53a.46.46 0 1 1 .64.659l-1.614 1.568a.46.46 0 0 1-.641-.66l1.615-1.568Z"
        fill="#ff6700"
      />
      <path
        data-name="Path 10353"
        d="M18.425 18.872a1.8 1.8 0 0 0 .71-1 .97.97 0 0 0-.027-.468.458.458 0 0 1 .388.783l-1.614 1.568a.459.459 0 0 1-.718-.557 1.455 1.455 0 0 0 1.261-.329Z"
        fill="#f25406"
      />
      <path
        data-name="Path 10354"
        d="M18.448 19.019a3.05 3.05 0 0 0 .984-1.274.825.825 0 0 0 .042-.231c.01.009.021.016.031.026a.459.459 0 0 1-.01.65l-1.614 1.568a.458.458 0 0 1-.774-.265 1.609 1.609 0 0 0 1.341-.474Z"
        fill="#cc4205"
      />
      <path
        data-name="Path 10355"
        d="M19.011 17.64c.127.279-.428.609-.627.768-.147.116-.777.7-.929.617.249-.221.484-.474.729-.713.201-.197.765-.808.827-.672Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10356"
        d="M15.103 14.05c0 .076-.1.2-.181.275a2.37 2.37 0 0 1-.3.213c-.346.246-.446.49-.642.566a3.119 3.119 0 0 1 .577-.661c.083-.08.515-.505.542-.394Z"
        fill="#fcaa51"
      />
      <path
        data-name="Path 10357"
        d="M12.3 14.88a2.185 2.185 0 0 0 .477-.305 10.09 10.09 0 0 0 1.713-1.628 3.188 3.188 0 0 0 .391-.608c.072-.15.083-.486.256-.525.495.024.514.439.194.719-.293.258-.608.475-.9.737a23.577 23.577 0 0 1-1.729 1.679c-.082.06-1 .525-.855.123.035-.093.362-.151.451-.193Z"
        fill="#fcaa51"
      />
    </g>
  </svg>
);

export default SvgComponent;
